import { startCase, truncate } from 'lodash';

export default Vue => {
  Vue.filter('tableHeader', startCase);
  Vue.filter('truncate', (value, length) => truncate(value, { length }));
};
